<template lang="pug">
    div.profile
        v-menu(v-model='openEditDialog' :nudge-width='400' absolute :close-on-content-click="false")
            template(v-slot:activator='{ on, attrs }')
                v-list-item.justify-center()
                    v-avatar.elevation-6.justify-center(size="175" v-bind='attrs' v-on='on' :ripple="false")
                        img(:src="image.imgURL") 
            v-card
                v-card-title.font-weight-bold.mt-n1 Change Profile Image
                v-card-text.my-n2
                    v-file-input(v-model="imageFile" hide-details outlined dense @change="onFileChange" accept="image/*")
                v-card-actions
                    v-spacer
                    v-btn.mb-2(small text @click.native="openEditDialog = false; imageFile = null") Cancel
                    v-btn.mb-2.mr-2(small depressed dark color="accent" @click="changeUrl()" :loading="isLoading") Upload
</template>
<script>
import { mapActions } from 'vuex'
export default {
    props:['image'],
    data: () => ({
        openEditDialog: false,
        imageFile: null,
        resizeImageFile: null,
        isLoading: false
    }),
    methods: {
        ...mapActions([
            'showMessage'
        ]),
        onFileChange () {
            if (!this.imageFile) { return }
            let file = this.imageFile
            let fileReader = new FileReader()
            fileReader.onload = e => {
                let image = new Image()
                image.onload = () => {
                    let canvas = document.createElement('canvas')
                    let maxSize = 960
                    let width = image.width
                    let height = image.height
                    let resizeFactor = 1.0
                    if (width > maxSize || height > maxSize) {
                        if (height > width) {
                        resizeFactor = maxSize / height
                        } else {
                        resizeFactor = maxSize / width
                        }
                    }
                    let resizeWidth = width * resizeFactor
                    let resizeHeight = height * resizeFactor
                    canvas.width = resizeWidth
                    canvas.height = resizeHeight
                    canvas.getContext('2d').drawImage(image, 0, 0, resizeWidth, resizeHeight)
                    canvas.toBlob((blob) => {
                        this.resizeImageFile = new File([blob], 'page_image_item.jpeg', {
                            type: 'image/jpeg',
                            lastModified: Date.now()
                        })
                    }, 'image/jpeg', 1)
                }
                image.src = e.target.result
            }
            fileReader.readAsDataURL(file)
        },
        changeUrl () {
        if (!this.resizeImageFile) { 
            this.showMessage(['error', this.$t('error_message.image_invalid')])
            return
        }
        this.isLoading = true
        var params = new FormData()
        params.append('file', this.resizeImageFile)
        this.$axios.post(`/documents/`, params)
            .then(resp => {
                this.image.imgURL = resp.data.file
                this.openEditDialog = false
            })
            .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
            })
            .finally(() => {
                this.isLoading = false
            })

        }
    }
}
</script>
<style scoped>
 .profile{
    margin-top:-95px;
    width: 300px;
    margin-left: auto;
    margin-right: auto;
 }
</style>